import { CometChat } from "@cometchat-pro/chat";
import { COMETCHAT_CONSTANTS } from "../../configs/keys";
import { cometGetUser, cometUserUpdate } from "../../helper_functions/CometChatFunctions";

export const SET_COMET_USER_STATE = "SET_COMET_USER_STATE";
export const SET_COMET_USER_DATA = "SET_COMET_USER_DATA";
export const SET_COMET_USER_UID = "SET_COMET_USER_UID";
export const SET_REFERRAL_ORDER = "SET_REFERRAL_ORDER";
export const RESET_COMET_STATE = "RESET_COMET_STATE";
export const SET_COMET_CHAT_WITH_UID = "SET_COMET_CHAT_WITH_UID"
export const SET_NOT_LOGGED_IN_CONTEXT = "SET_NOT_LOGGED_IN_CONTEXT"

export const setCometUserState = (data) => {
    const actionOBject = {
        type: SET_COMET_USER_STATE,
        payload: data
    };
    return actionOBject;
};

export const setCometUserData = (data) => {
    const actionOBject = {
        type: SET_COMET_USER_DATA,
        payload: data
    };
    return actionOBject;
};

export const setCometUid = (data) => {
    const actionOBject = {
        type: SET_COMET_USER_UID,
        payload: data
    };
    return actionOBject;
};

export const setChatWithReceiver = (data) => {
    const actionOBject = {
        type: SET_COMET_CHAT_WITH_UID,
        payload: data
    };
    return actionOBject;
};

export const setReferralOrder = (data) => {
    const actionOBject = {
        type: SET_REFERRAL_ORDER,
        payload: data
    };
    return actionOBject;
};

export const setNotLoggedInChatContext = (data) => {
    const actionOBject = {
        type: SET_NOT_LOGGED_IN_CONTEXT,
        payload: data
    };
    return actionOBject;
};

export const resetCometState = () => {
    const actionOBject = {
        type: RESET_COMET_STATE,
    };
    return actionOBject;
};


export const updateUserState = (data) => (dispatch) => {
    dispatch(setCometUserState(data))
}

export const updateChatWithReceiver = (uid, additionalData, type) => (dispatch) => {
    if (type && type === 'nonChatMetaUpdate' && additionalData && Object.keys(additionalData).length > 0) {
        const orderContextData = {
            referenceOrder: additionalData.referenceOrderId,
            referenceUid: uid,
            orderMarkedToStatus: additionalData.orderMarkedTo,
            newMetaDataRefObj: additionalData
        }
        dispatch(setReferralOrder(orderContextData))

        cometGetUser(uid).then((res) => {
            if (res.status === true) {
                const user = res.data
                cometUserUpdate(additionalData, user, additionalData.to_uid, orderContextData)
                    .then((resp) => {
                        if (resp?.status === true &&
                            resp?.data?.metadata &&
                            user?.uid === resp?.data?.uid
                        ) {
                            //Metadata updated
                        }
                    }).catch((err) => {
                        // Err while updating metadata
                    })
            }
        }).catch((err) => {
            // Error while fetching user details
        })
    } else if (additionalData && Object.keys(additionalData).length) {
        dispatch(setReferralOrder(
            {
                referenceOrder: additionalData.referenceOrderId,
                referenceUid: uid,
                orderMarkedToStatus: additionalData.orderMarkedTo,
                newMetaDataRefObj: additionalData
            }
        ))
        dispatch(setChatWithReceiver(uid))
    } else {
        //No data found while updating chat with receiver
        dispatch(setReferralOrder(undefined))
        dispatch(setChatWithReceiver(uid))
    }
}

export const updateCoverWindowChat = (data) => (dispatch) => {
    dispatch(setNotLoggedInChatContext(data))
}

export const updateActiveCometUserData = (data) => (dispatch) => {
    dispatch(setCometUserData(data))
}

export const updateActiveCometUser = (data) => (dispatch) => {
    dispatch(setCometUid(data))
}

export const removeCometData = () => (dispatch) => {
    dispatch(resetCometState())
}

export const initializeCometChat = () => (dispatch) => {
    const appSetting = new CometChat.AppSettingsBuilder()
        .subscribePresenceForAllUsers()
        .setRegion(COMETCHAT_CONSTANTS.REGION)
        .build();

    CometChat.init(COMETCHAT_CONSTANTS.APP_ID, appSetting).then(
        () => {
            dispatch(setCometUserState(1))
        },
        (error) => {
            //second initialization failed as well
            dispatch(setCometUserState(0))
        }
    );
};